import pushToGaDataLayer from '~/utils/pushToGaDataLayer'

interface WizardsLogoutOptions {
  clearNotificationState?: () => void | Promise<void>
  navigate?: (url: string) => unknown
  trackLogout?: () => void
  reportError?: (error: unknown) => void
}

/** Clear client-only notification state before leaving the WPN session. */
export const useWizardsLogout = (options: WizardsLogoutOptions = {}) => {
  const clearNotificationState =
    options.clearNotificationState ||
    (() => useSiteNotificationStore().clearOnLogout())
  const navigate =
    options.navigate || ((url: string) => navigateTo(url, { external: true }))
  const trackLogout =
    options.trackLogout ||
    (() =>
      pushToGaDataLayer({
        event: 'ga4.trackEvent',
        eventName: 'logout',
        eventParams: { method: 'WOTC' },
      }))
  const reportError =
    options.reportError ||
    ((error: unknown) => console.error('[logout] failed to log out', error))

  const logout = async () => {
    try {
      // This intentionally happens before the network request or navigation.
      await clearNotificationState()
      trackLogout()
      // Navigate directly to the local route (not `$fetch`) so the server's
      // redirect to the OIDC end-session endpoint is a top-level navigation
      // instead of a CORS-blocked fetch.
      await navigate('/auth/logout')
    } catch (error) {
      reportError(error)
    }
  }

  return { logout }
}
